import styled, { css } from 'styled-components';
import { layout, remCalc, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

import ReviewSummaryBase from '../../components/review-summary';
import UserReviewCardComponent from '../../components/user-review-card';

const InfoLink = styled.div`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};
  text-align: center;
  line-height: 1.5;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }

  a {
    display: flex;
    align-items: center;
    column-gap: ${layout.spacing.xxSmall};
  }

  a,
  a:hover {
    color: inherit;
  }
`;

const OldReviewsHeader = styled.div`
  padding-top: ${layout.margins.wrapper.desktop.rem};
  border-top: 1px solid ${p => p.theme.lines.primary};
  margin-top: ${layout.margins.component.desktop.rem};

  ${media.mediumDown`
    padding-top: ${layout.margins.wrapper.mobile.rem};
    margin-top: ${layout.margins.component.mobile.rem};
  `}
`;

const SortedBy = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${p => p.theme.text.tertiary};
  font-size: ${remCalc(12)};
`;

const EditButton = styled.button`
  cursor: pointer;
  color: ${p => p.theme.text.callToAction};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

type SummaryProps = {
  firstToReview: boolean;
};

const Summary = styled.div.attrs({ 'data-test': 'ReviewsSummary' })<
  SummaryProps
>`
  display: grid;
  grid-template-columns: ${p => (p.firstToReview ? '4fr' : '4fr 1fr')};

  padding: ${layout.spacing.small} ${layout.spacing.small};
  background: ${props => props.theme.bg.secondary};
  margin-bottom: ${layout.spacing.xSmall};
  column-gap: ${layout.spacing.xSmall};
  row-gap: ${layout.spacing.small};
  min-height: 120px;

  ${media.mediumDown`
    display: flex;
    flex-direction: column;
    padding: ${layout.spacing.xSmall};
  `};
`;

type PromptProps = {
  highlighted?: boolean;
};

const Prompt = styled.div<PromptProps>`
  margin: ${props => (props.highlighted ? '15px auto' : '0 0 0 auto')};
  text-align: center;

  ${media.mediumDown`
    margin: 0;
  `};
`;

export const ReviewSummary = styled(ReviewSummaryBase)`
  ${media.largeUp`
    width: 500px;
  `};
`;

type SummaryButtons = {
  hasReviews?: boolean;
};

export const SummaryButtons = styled.div<SummaryButtons>(
  props => css`
    margin-left: auto;
    margin-right: ${props.hasReviews ? 0 : 'auto'};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    row-gap: ${layout.spacing.small};

    ${media.mediumDown`
      width: 100%;
      flex-direction: row;
      padding: ${layout.spacing.xSmall};
      justify-content: ${props.hasReviews ? 'space-between' : 'center'};
      align-items: flex-end;
    `};
  `
);

type UserReviewCardProps = {
  fullWidth?: boolean;
};

export const UserReviewCard = styled(UserReviewCardComponent)<
  UserReviewCardProps
>(
  p => css`
    margin-bottom: ${layout.spacing.small};

    ${p.fullWidth &&
      css`
        grid-template-columns: 0 1fr 0;
      `};

    ${media.mediumDown`
      margin-bottom: ${layout.spacing.xSmall};
    `};
  `
);

type CreateReviewButton = {
  count?: number;
};

export const CreateReviewButton = styled(Button)<CreateReviewButton>(
  p => css`
    ${media.mediumDown`
     ${p.count &&
       css`
         padding: 0;
       `};
    `};
  `
);
export { InfoLink, OldReviewsHeader, SortedBy, EditButton, Summary, Prompt };
